import { DataUtilities } from "../../DataUtilities";
import { IDataDefinition } from "../Definitions/IDataDefinition";
import { ObjectDataDefinition } from "../Definitions/ObjectDataDefinition";
import { DataDefinition } from "../DataDefinition";
import { DataStructureDifferences } from "./DataStructureDifferences";

export class EditFieldToDataStructure implements DataStructureDifferences {
    field: IDataDefinition;
    path: string;

    constructor(field: IDataDefinition, path: string) {
        this.field = field;
        this.path = path;
    }

    getMessage() {
        // const pieces: string[] = this.path.split(".");
        // const path = pieces.length > 1 ? pieces.join(" -> ") : "root";
        return `Update Field ${this.field.name}`;
    }

    apply(def: DataDefinition) {
        let pieces: string[] = this.path.split(".");

        if (pieces.length === 1) {
            let idx = def.fields.findIndex((f) => f.name === this.path);
            def.fields.splice(idx, 1, this.field);
        } else if (pieces.length > 1) {
            let parentPath = pieces.slice(0, -1).join(".");

            let parentField = DataUtilities.getFieldFromDataDefinitionByName(
                def.fields,
                parentPath
            ) as ObjectDataDefinition;

            let idx = parentField.fields.findIndex((f) => f.name === pieces[pieces.length - 1]);
            parentField.fields.splice(idx, 1, this.field);
        }
    }
}
